<div class="data_opzioni opzioni-file" appDropdownFocus>
  <a style="color: #555;" aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown" href="#" role="button">Opzioni
    <span class="glyphicon glyphicon-option-vertical"></span>
  </a>
  <div class="dropdown-menu menu-file-dir">
    <ul>

      <!-- DOWNLOAD DOCUMENTO -->
      <li *ngIf="isOperationEnabled('download', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-save-file"></span>
        <a href="javascript:void(0);" (click)="downloadFile(item.code, item.documento)">Download documento</a>
      </li>
      <li *ngIf="!isOperationEnabled('download', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-save-file"></span>
       Download documento
      </li>

      <!-- UPLOAD NUOVA VERSIONE -->
      <li *ngIf="isOperationEnabled('uploadVersion', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-open-file"></span>
        <a href="javascript:void(0);" (click)="openModalCallback(item.documento)">Upload nuova versione</a>
      </li>
      <li *ngIf="!isOperationEnabled('uploadVersion', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-open-file"></span>
        Upload nuova versione
      </li>

      <!-- SPOSTA DOCUMENTO -->
      <li *ngIf="isOperationEnabled('move', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-pencil"></span>
        <a href="javascript:void(0);" (click)="openMoveDocModal(item.documento)">Sposta in</a>
      </li>
      <li *ngIf="!isOperationEnabled('move', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-pencil"></span>
        Sposta in
      </li>

      <!-- DETTAGLIO -->
      <li *ngIf="isOperationEnabled('viewDetail', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-eye-open"></span>
        <a href="javascript:void(0);" (click)="openDetailModal(item.documento)">Dettaglio</a>
      </li>
      <li *ngIf="!isOperationEnabled('viewDetail', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-eye-open"></span>
        Dettaglio
      </li>

      <!-- MODIFICA METADATI -->
      <li *ngIf="isOperationEnabled('editMetadata', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-edit"></span>
        <a href="javascript:void(0)" (click)="openUpdateMetadatiModal(item.documento, item)">Modifica metadati documento</a>
      </li>
      <li *ngIf="!isOperationEnabled('editMetadata', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-edit"></span>
        Modifica metadati documento
      </li>

      <!-- STORICO VERSIONI -->
      <li *ngIf="isOperationEnabled('viewHistory', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-calendar"></span>
        <a href="javascript:void(0);" (click)="openHistoryModalCallback(item.documento)">Visualizza storico versioni</a>
      </li>
      <li *ngIf="!isOperationEnabled('viewHistory', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-calendar"></span>
        Visualizza storico versioni
      </li>

      <!-- PROTOCOLLA DOCUMENTO -->
      <li *ngIf="item?.section?.esn==='SezioneDocumentazioneAllegata' && isOperationEnabled('protocol', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-open-file"></span>
        <a href="javascript:void(0);" (click)="openProtocolModal(item.documento)">Protocolla</a>
      </li>
      <li *ngIf="item?.section?.esn==='SezioneDocumentazioneAllegata' && !isOperationEnabled('protocol', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-open-file"></span>
        Protocolla
      </li>

      <!-- FIRMA DOCUMENTO -->
      <li *ngIf="isOperationEnabled('sign', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-pencil"></span>
        <a href="javascript:void(0);" (click)="openFirmaModal(item.documento)">Firma</a>
      </li>
      <li *ngIf="!isOperationEnabled('sign', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-pencil"></span>
        Firma
      </li>

      <!-- TIMBRA DOCUMENTO -->
      <li *ngIf="isOperationEnabled('stamp', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}" style="display: inline-flex; align-items: center;">
        <img src="img/stamp.png" alt="timbro" style="width: 18px; height: 18px; vertical-align: middle;">
        <a href="javascript:void(0);" style="margin-left: 12px;" (click)="openTimbraModal(item.documento)">Timbra</a>
      </li>
      <li *ngIf="!isOperationEnabled('stamp', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <img src="img/stamp.png" alt="timbro" style="width: 18px; height: 18px; vertical-align: middle;">
        Timbra
      </li>

      <!-- ANNULLA PROTOCOLLO -->
      <li *ngIf="isOperationEnabled('cancelProtocol', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-remove-circle"></span>
        <a href="javascript:void(0);" (click)="openAnnullaProtocolModal(item.documento)">Annulla documento protocollato</a>
      </li>
      <li *ngIf="!isOperationEnabled('cancelProtocol', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-remove-circle"></span>
        Annulla documento protocollato
      </li>

      <!-- ELIMINA DOCUMENTO -->
      <li *ngIf="isOperationEnabled('delete', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-trash"></span>
        <a href="javascript:void(0);" (click)="deleteDocNotify(item.documento,item)">Elimina documento</a>
      </li>
      <li *ngIf="!isOperationEnabled('delete', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-trash"></span>
        Elimina documento
      </li>

      <!-- IMPOSTA COME PRINCIPALE -->
      <li *ngIf="isOperationEnabled('editPrincipale', item)" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-star"></span>
        <a href="javascript:void(0)" (click)="setAsPrincipale(item.documento,item?.section?.id)">Imposta come principale</a>
      </li>
      <li *ngIf="!isOperationEnabled('editPrincipale', item)" class="disabilitata" [ngStyle]="{'margin-bottom': isTable ? '12px' : '0'}">
        <span class="glyphicon glyphicon-star"></span>
        Imposta come principale
      </li>
    </ul>
  </div>
</div>




